import { Link } from 'react-router-dom'

const SECOES = [
  {
    titulo: '1. Quem somos',
    blocos: [
      'O Sistema Descubra seus Óleos (descubraseusoleos.com.br) é operado por Mônica Maria, aromaterapeuta e terapeuta integrativa, inscrita como MEI (Microempreendedora Individual). Para dúvidas sobre esta política ou sobre seus dados, entre em contato pelo WhatsApp +55 81 98867-1210.',
    ],
  },
  {
    titulo: '2. Quais dados coletamos',
    intro: 'Coletamos os seguintes dados, dependendo de como você usa o site:',
    itens: [
      'Diagnóstico de Saúde e Emoções (adulto e kids): nome, e-mail, WhatsApp, e as respostas fornecidas sobre saúde física e emocional.',
      'Cadastro de consultoras: nome, e-mail, WhatsApp, dados de assinatura e pagamento (processados pela Hotmart).',
      'Jornadas e cursos (Vivências, Jornada Compartilhe, Cursos de Aromaterapia): nome e e-mail de quem se cadastra ou é convidado por uma consultora.',
      'Navegação: dados de cookies e ferramentas de anúncio (como o Meta Pixel), usados apenas em páginas específicas e apenas mediante seu consentimento, quando aplicável.',
    ],
  },
  {
    titulo: '3. Para que usamos seus dados',
    itens: [
      'Gerar e entregar o resultado do seu diagnóstico de bem-estar.',
      'Permitir que a consultora responsável pelo seu atendimento acesse suas respostas para dar orientações personalizadas.',
      'Processar o pagamento de assinaturas e produtos, por meio da Hotmart.',
      'Enviar comunicações relacionadas ao seu diagnóstico, jornada ou curso.',
      'Medir a performance de campanhas de anúncio, apenas nas páginas onde há consentimento explícito (aviso de cookies).',
    ],
    destaque:
      'Não utilizamos suas respostas de saúde e emoções para fins de anúncio ou publicidade. Essas informações não são compartilhadas com ferramentas de rastreamento como o Meta Pixel.',
  },
  {
    titulo: '4. Com quem compartilhamos seus dados',
    itens: [
      'Hotmart: processamento de pagamentos de assinaturas e produtos.',
      'Consultora responsável: quando você preenche um diagnóstico através do link de uma consultora específica, suas respostas de contato ficam visíveis para essa consultora, para fins de atendimento.',
      'Meta (Facebook/Instagram): apenas dados de navegação (como visita à página e conclusão do diagnóstico), e apenas quando você consentir no aviso de cookies. Nunca incluímos suas respostas, nome, e-mail ou telefone nesses eventos.',
    ],
    extra: 'Não vendemos seus dados a terceiros.',
  },
  {
    titulo: '5. Cookies e ferramentas de anúncio',
    blocos: [
      'Em algumas páginas específicas, utilizamos cookies para medir o resultado de campanhas de anúncio. Você pode aceitar ou recusar esse uso através do aviso exibido na página. Recusar não impede o uso do diagnóstico ou de qualquer funcionalidade do site.',
    ],
  },
  {
    titulo: '6. Por quanto tempo guardamos seus dados',
    blocos: [
      'Mantemos seus dados pelo tempo necessário para a finalidade de coleta (atendimento, acompanhamento, obrigações fiscais e legais), ou até que você solicite a exclusão, conforme descrito abaixo.',
    ],
  },
  {
    titulo: '7. Seus direitos',
    intro: 'De acordo com a Lei Geral de Proteção de Dados (LGPD), você pode, a qualquer momento:',
    itens: [
      'Confirmar se tratamos seus dados;',
      'Acessar os dados que temos sobre você;',
      'Corrigir dados incompletos ou desatualizados;',
      'Solicitar a exclusão dos seus dados;',
      'Revogar o consentimento dado (por exemplo, para cookies de anúncio).',
    ],
    extra: 'Para exercer qualquer um desses direitos, entre em contato pelo WhatsApp +55 81 98867-1210.',
  },
  {
    titulo: '8. Segurança',
    blocos: [
      'Adotamos medidas técnicas e organizacionais para proteger seus dados contra acessos não autorizados, perda ou uso indevido.',
    ],
  },
  {
    titulo: '9. Alterações nesta política',
    blocos: [
      'Esta política pode ser atualizada periodicamente. A data da última atualização estará sempre indicada no topo desta página.',
    ],
  },
]

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      <header className="bg-[#2D6A4F] text-white px-4 py-8">
        <div className="mx-auto max-w-3xl">
          <p className="text-xs font-dm-sans tracking-wide uppercase text-white/80 mb-2">
            Diagnóstico de Saúde e Emoções
          </p>
          <h1 className="font-cormorant font-semibold text-3xl sm:text-4xl leading-tight">
            Política de Privacidade
          </h1>
          <p className="mt-3 text-sm font-dm-sans text-white/85">
            Última atualização: abril de 2026
          </p>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 space-y-8">
        {SECOES.map((secao) => (
          <section key={secao.titulo} className="bg-white rounded-2xl shadow-sm border border-[#EDE0D4] p-6 sm:p-8">
            <h2 className="font-cormorant font-semibold text-2xl text-[#2C2C2A] mb-4">
              {secao.titulo}
            </h2>
            {secao.intro ? (
              <p className="text-sm sm:text-base text-[#5F5E5A] font-dm-sans leading-relaxed mb-3">
                {secao.intro}
              </p>
            ) : null}
            {secao.blocos?.map((texto) => (
              <p key={texto} className="text-sm sm:text-base text-[#5F5E5A] font-dm-sans leading-relaxed">
                {texto}
              </p>
            ))}
            {secao.itens ? (
              <ul className="space-y-2">
                {secao.itens.map((item) => (
                  <li key={item} className="text-sm sm:text-base text-[#5F5E5A] font-dm-sans leading-relaxed pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-[#2D6A4F]">
                    {item}
                  </li>
                ))}
              </ul>
            ) : null}
            {secao.destaque ? (
              <p className="mt-4 text-sm sm:text-base text-[#2C2C2A] font-dm-sans leading-relaxed bg-[#D8F3DC] border-l-4 border-[#2D6A4F] rounded-r-xl px-4 py-3">
                {secao.destaque}
              </p>
            ) : null}
            {secao.extra ? (
              <p className="mt-4 text-sm sm:text-base text-[#5F5E5A] font-dm-sans leading-relaxed">
                {secao.extra}
              </p>
            ) : null}
          </section>
        ))}

        <p className="text-center">
          <Link
            to="/"
            className="inline-flex min-h-[44px] items-center text-sm font-dm-sans text-[#2D6A4F] underline underline-offset-2 hover:text-[#245A42]"
          >
            Voltar ao início
          </Link>
        </p>
      </main>
    </div>
  )
}
